
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire40f7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire40f7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hMTg2", function(module, exports) {

$parcel$export(module.exports, "captureEvents", function () { return $cf31c85cca08914a$export$a12732eb8ef45f6a; });
$parcel$export(module.exports, "findEventByPrivateApiKey", function () { return $cf31c85cca08914a$export$e6a36f7b37c560ba; });
$parcel$export(module.exports, "regByWebappIdFirstStep1", function () { return $cf31c85cca08914a$export$309064234c7f14e9; });
$parcel$export(module.exports, "joinAttendeeIds", function () { return $cf31c85cca08914a$export$825ac59bb370e6d4; });

var $itWG1 = parcelRequire("itWG1");

var $k2vBO = parcelRequire("k2vBO");
function $cf31c85cca08914a$var$haveAdminPerm(keyType) {
    return keyType === null;
}
function $cf31c85cca08914a$var$safeParseJSON(opts) {
    return opts && JSON.parse(opts) || {};
}
const $cf31c85cca08914a$var$restApi = (0, $k2vBO.initRequest)("https://api-new.occo.io/v1");
const $cf31c85cca08914a$var$defaultImgPath = "https://images.occo.io";
const $cf31c85cca08914a$var$PREVIEW_STATUS_DONE = 'DONE';
const $cf31c85cca08914a$var$PREVIEW_STATUS_FAILED = 'FAILED';
const $cf31c85cca08914a$var$DEFAULT_PREVIEW_INTERVAL_MS = 10000;
const $cf31c85cca08914a$var$DEFAULT_PREVIEW_MAX_REQUESTS = 20;
const $cf31c85cca08914a$var$DEFAULT_PREVIEW_TIMEOUT_SECONDS = 120;
function $cf31c85cca08914a$var$unwrapOccoOwnerResponse(response) {
    if (response?.status === 'nok') {
        const error = response.error || {};
        if (!error.message_key && response.error_message_key) error.message_key = response.error_message_key;
        if (!error.message) error.message = response.error?.message_text || response.error_message_key || 'Request failed';
        throw error;
    }
    return response?.result ?? null;
}
function $cf31c85cca08914a$var$generateTmpUploadId() {
    return (Date.now() - new Date('2017-01-01').getTime()) * 8192 + Math.floor(Math.random() * 8192);
}
function $cf31c85cca08914a$var$sanitizeAssetFileName(fileName = '') {
    return String(fileName).replaceAll(/\s/g, '');
}
function $cf31c85cca08914a$var$delay(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $cf31c85cca08914a$var$normalizePositiveInteger(value, fallbackValue) {
    const normalizedValue = Number(value);
    if (!Number.isFinite(normalizedValue) || normalizedValue <= 0) return fallbackValue;
    return Math.floor(normalizedValue);
}
function $cf31c85cca08914a$var$normalizePreviewUrl(value) {
    const normalizedValue = String(value || '').trim();
    return normalizedValue || null;
}
function $cf31c85cca08914a$var$getPreviewMessage(result, fallbackMessage) {
    return result?.data?.error || result?.message_text || result?.messageText || result?.message_key || fallbackMessage;
}
function $cf31c85cca08914a$var$normalizePreviewResponse(result) {
    const previewData = result?.data || result || {};
    const generatedResourceUrl = $cf31c85cca08914a$var$normalizePreviewUrl(previewData.generatedResourceUrl || previewData.generated_resource_url || previewData.main_image_url);
    const thumbImageUrl = $cf31c85cca08914a$var$normalizePreviewUrl(previewData.thumbImageUrl || previewData.thumb_image_url);
    return {
        generatedResourceUrl: generatedResourceUrl,
        thumbImageUrl: thumbImageUrl
    };
}
async function $cf31c85cca08914a$export$a12732eb8ef45f6a(param) {
    const events = getEvents();
    if (!events || events.length === 0) return;
    return $cf31c85cca08914a$var$restApi.post('/activity/capture-event', events);
    function getEvents() {
        if (Array.isArray(param)) return param;
        return [
            param
        ];
    }
}
async function $cf31c85cca08914a$export$bb613c728286d830(file, { eventName: eventName, attendeeUId: attendeeUId, keepOriginName: keepOriginName = true }) {
    return $cf31c85cca08914a$var$getAccessToUploadInS3({
        eventName: eventName,
        fileName: file.name,
        attendeeUId: attendeeUId,
        keepOriginName: keepOriginName
    }).then((resp)=>resp.result).then((result)=>(0, $k2vBO.sendFileToS3)(file, {
            s3key: result.fields.key,
            s3bucketUrl: result.url,
            s3fields: result.fields,
            defaultImgPath: $cf31c85cca08914a$var$defaultImgPath
        }));
}
async function $cf31c85cca08914a$var$getAccessToUploadInS3({ eventName: eventName, fileName: fileName, attendeeUId: attendeeUId, keepOriginName: keepOriginName = true }) {
    return $cf31c85cca08914a$var$restApi.post('/event/tmp-photo-upload-access/retrieve', {
        event_name: eventName,
        file_name: fileName,
        keep_origin_name: keepOriginName,
        attendee_uid: attendeeUId
    });
}
async function $cf31c85cca08914a$export$261b4884ce0c342c(file, { attendeeId: attendeeId, eventName: eventName }) {
    const now = new Date();
    const selfiePath = `${eventName}/${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}/${file.name}`;
    return $cf31c85cca08914a$var$getAccessToUploadInS3Selfie(selfiePath).then((resp)=>resp.result).then((result)=>(0, $k2vBO.sendFileToS3)(file, {
            s3key: result.fields.key,
            s3bucketUrl: result.url,
            s3fields: result.fields,
            defaultImgPath: $cf31c85cca08914a$var$defaultImgPath
        })).then((imgSrc)=>$cf31c85cca08914a$var$addToDBSelfie({
            attendeeId: attendeeId,
            imgSrc: imgSrc,
            eventName: eventName
        }));
}
async function $cf31c85cca08914a$var$addToDBSelfie({ attendeeId: attendeeId, imgSrc: imgSrc, eventName: eventName }) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/profile-photo/create', {
        attendee_uid: attendeeId,
        full_path: imgSrc,
        event_name: eventName
    });
}
async function $cf31c85cca08914a$var$getAccessToUploadInS3Selfie(fileName) {
    return $cf31c85cca08914a$var$restApi.post('/photo/tmp-upload-access/retrieve', {
        file_relative_path: fileName
    });
}
async function $cf31c85cca08914a$export$7109c3452fbff301({ eventOwnerApiKey: eventOwnerApiKey, photoUrlList: photoUrlList, faceMatchThreshold: faceMatchThreshold = 60, isKiosk: isKiosk = false, startDate: startDate, endDate: endDate }) {
    return $cf31c85cca08914a$var$restApi.post('/photo/search-by-face', {
        event_owner_api_key: eventOwnerApiKey,
        photo_url_list: photoUrlList,
        face_match_threshold: faceMatchThreshold,
        isKiosk: isKiosk,
        start_date: startDate,
        end_date: endDate
    });
}
async function $cf31c85cca08914a$export$7bdb0b3c8e430fa1(attendeeId) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/profile-photo/list/retrieve', {
        attendee_uid: attendeeId
    });
}
async function $cf31c85cca08914a$export$83e5cfb779ec03dc(attendeeId, photoUId) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/profile-photo/delete', {
        attendee_uid: attendeeId,
        photo_uid: photoUId
    });
}
async function $cf31c85cca08914a$export$f0d01cb7f4fd90ce({ eventName: eventName, basicDataOnly: basicDataOnly = false }) {
    const response = await $cf31c85cca08914a$var$restApi.post('/event/retrieve', {
        event_name: eventName,
        basicDataOnly: basicDataOnly
    });
    if (response.result) response.result.opts = $cf31c85cca08914a$var$safeParseJSON(response.result.opts);
    return response;
}
async function $cf31c85cca08914a$export$e6a36f7b37c560ba({ id: id }) {
    const response = await $cf31c85cca08914a$var$restApi.post('/event/list/retrieve', {
        key_type: 'event_private_api_key',
        key_value: id,
        max_size: 1,
        page_number: 1
    });
    const event = response.result.dataList[0];
    event.opts = $cf31c85cca08914a$var$safeParseJSON(event.opts);
    return {
        result: event,
        status: response.status
    };
}
async function $cf31c85cca08914a$export$309064234c7f14e9({ eventName: eventName } = {}) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/create/by-webapp-id-first/step-1', eventName ? {
        eventName: eventName
    } : {});
}
async function $cf31c85cca08914a$export$5a9a02b716a313b2({ eventId: eventId, attendeeUid: attendeeUid, attendeeName: attendeeName, attendeeEmail: attendeeEmail, attendeePhoneNumber: attendeePhoneNumber }) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/create/by-webapp-id-first/step-2', {
        eventId: eventId,
        attendeeUid: attendeeUid,
        attendeeName: attendeeName,
        attendeeEmail: attendeeEmail,
        attendeePhoneNumber: attendeePhoneNumber
    });
}
function $cf31c85cca08914a$export$825ac59bb370e6d4({ attendeeUIds: attendeeUIds, eventPrivateApiKey: eventPrivateApiKey }) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/check-and-group-uid-list', {
        attendee_uid_list: attendeeUIds,
        event_private_api_key: eventPrivateApiKey
    });
}
async function $cf31c85cca08914a$export$4d692b4aa5f5532d({ eventName: eventName, uId: uId, vDate: vDate, lat: lat, long: long, lang: lang, prePaid: prePaid = false, email: email }) {
    return $cf31c85cca08914a$var$restApi.post('/genting-app/add-visit-date-info', {
        app_info_obj: {
            uId: uId,
            vDate: vDate && prepareDate(),
            lat: lat,
            long: long,
            lang: lang,
            prePaid: prePaid,
            email: email,
            eventName: eventName
        }
    });
    function prepareDate() {
        const year = vDate.getFullYear();
        const month = padTo2Digits(vDate.getMonth() + 1);
        const day = padTo2Digits(vDate.getDate());
        return `${year}${month}${day}`;
    }
    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    }
}
async function $cf31c85cca08914a$export$c2d084dc44961371({ eventId: eventId, attendeeUid: attendeeUid, printerPoolName: printerPoolName, photosUid: photosUid, copies: copies = 0, isStory: isStory = false }, { keyType: keyType = null, keyValue: keyValue = null } = {}) {
    return $cf31c85cca08914a$var$restApi.post(determinePath(), prepareBody());
    function determinePath() {
        return $cf31c85cca08914a$var$haveAdminPerm(keyType) ? '/occo-owner/photo/print-with-queue' : '/photo/print-with-queue';
    }
    function prepareBody() {
        const body = {
            event_id: eventId,
            attUid: attendeeUid,
            printable_photo_uid_array: photosUid,
            printing_count: copies + 1,
            printer_pool_name: printerPoolName,
            isStory: isStory
        };
        if (!$cf31c85cca08914a$var$haveAdminPerm(keyType)) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        return body;
    }
}
async function $cf31c85cca08914a$export$3e45e94f46f8bebe(attendeeUid) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/retrieve', {
        attendee_uid: attendeeUid
    });
}
async function $cf31c85cca08914a$export$51f2efc35f7641ae({ attendeeUid: attendeeUid, email: email, name: name, phoneNumber: phoneNumber, eventCode: eventCode }) {
    return $cf31c85cca08914a$var$restApi.post('/attendee/update-by-kiosk', {
        attendee_uid: attendeeUid,
        email_address: email,
        full_name: name,
        phone_number: phoneNumber,
        event_name: eventCode,
        app_url: undefined
    });
}
async function $cf31c85cca08914a$export$8f8f5499952f3b39(attendeeUid, eventId) {
    return $cf31c85cca08914a$var$restApi.post('/event/attendee/retrieve', {
        attendeeUid: attendeeUid,
        eventId: eventId
    });
}
async function $cf31c85cca08914a$export$69549842e1b45fb3({ eventId: eventId, attId: attId, maxSize: maxSize, pageNumber: pageNumber = null, keyType: keyType = null, keyValue: keyValue = null, isVisible: isVisible = null, startDate: startDate = null, endDate: endDate = null, minInterval: minInterval = null, maxInterval: maxInterval = null, forKiosk: forKiosk = false, isCuratable: isCuratable = null, isCurated: isCurated = null, isOriginal: isOriginal = null, printable: printable = null, printed: printed = null, showTotalCount: showTotalCount = false, fileName: fileName = null, getFromTmp: getFromTmp = null, includeFavorites: includeFavorites = false }) {
    return $cf31c85cca08914a$var$restApi.post(determinePath(), prepareBody());
    function determinePath() {
        return $cf31c85cca08914a$var$haveAdminPerm(keyType) ? '/occo-owner/photo/list/retrieve' : '/photo/list/retrieve';
    }
    function prepareBody() {
        const body = {
            event_id: eventId,
            max_size: maxSize,
            page_number: pageNumber,
            min_time_minutes_interval: minInterval,
            max_time_minutes_interval: maxInterval,
            is_kiosk: forKiosk,
            is_curatable: isCuratable,
            is_curated: isCurated,
            is_original: isOriginal,
            printable: printable,
            printed: printed,
            file_name: fileName,
            attendee_uid: attId,
            show_total_count: showTotalCount,
            get_from_tmp: getFromTmp,
            include_favorites: Boolean(includeFavorites)
        };
        if (typeof isVisible !== 'undefined' && isVisible !== null && isVisible !== '' && isVisible !== 'null') body.is_visible = isVisible;
        if (startDate) body.start_date = startDate;
        if (endDate) body.end_date = endDate;
        if (!$cf31c85cca08914a$var$haveAdminPerm(keyType)) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        return body;
    }
}
async function $cf31c85cca08914a$export$abf742e0032fe27b(imageProcessListOptions = {}) {
    const { token: token = null, accessCode: accessCode = null } = imageProcessListOptions;
    const requestPath = getRequestPath();
    const body = buildRequestBody();
    const options = getOptions();
    return $cf31c85cca08914a$var$restApi.post(requestPath, body, options);
    function getRequestPath() {
        return $cf31c85cca08914a$var$haveAdminPerm(token) ? '/occo-owner/image-process/basic-list/retrieve' : '/image-process/basic-list/retrieve';
    }
    function buildRequestBody() {
        const reqBody = {};
        if (token) {
            reqBody.token = token;
            reqBody.accessCode = accessCode;
        }
        return reqBody;
    }
    function getOptions() {
        return {
            addAuth: $cf31c85cca08914a$var$haveAdminPerm(token)
        };
    }
}
async function $cf31c85cca08914a$export$bd1a2a9d9f6d374d() {
    return $cf31c85cca08914a$var$restApi.post('/occo-owner/image-process/summary-list/retrieve', {}, {
        addAuth: true
    }).then((response)=>{
        const result = $cf31c85cca08914a$var$unwrapOccoOwnerResponse(response);
        return Array.isArray(result) ? result : [];
    });
}
async function $cf31c85cca08914a$export$247f5eb9729df0bf(id) {
    return $cf31c85cca08914a$var$restApi.post('/occo-owner/image-process/retrieve', {
        id: id
    }, {
        addAuth: true
    }).then($cf31c85cca08914a$var$unwrapOccoOwnerResponse);
}
async function $cf31c85cca08914a$export$b4672c9aa875cc79(body = {}) {
    return $cf31c85cca08914a$var$restApi.post('/occo-owner/image-process/create', body, {
        addAuth: true
    }).then($cf31c85cca08914a$var$unwrapOccoOwnerResponse);
}
async function $cf31c85cca08914a$export$716ec4730b02ec63(id, body = {}) {
    return $cf31c85cca08914a$var$restApi.post('/occo-owner/image-process/update', {
        id: id,
        ...body
    }, {
        addAuth: true
    }).then($cf31c85cca08914a$var$unwrapOccoOwnerResponse);
}
async function $cf31c85cca08914a$export$c89da2dbe91fee89(id, { enabled: enabled, updatedVersion: updatedVersion } = {}) {
    return $cf31c85cca08914a$var$restApi.post('/occo-owner/image-process/update-enabled', {
        id: id,
        enabled: enabled,
        updatedVersion: updatedVersion
    }, {
        addAuth: true
    }).then($cf31c85cca08914a$var$unwrapOccoOwnerResponse);
}
async function $cf31c85cca08914a$export$cde82e691c325047(file) {
    if (!file) return Promise.reject(new Error('file_required'));
    const sanitizedFileName = $cf31c85cca08914a$var$sanitizeAssetFileName(file.name) || 'asset';
    const fileRelativePath = `tmp/${$cf31c85cca08914a$var$generateTmpUploadId()}/${sanitizedFileName}`;
    return (0, $itWG1.uploadFileToAssets)({
        fileRelativePath: fileRelativePath,
        file: file
    });
}
async function $cf31c85cca08914a$export$c8ced387ca8605ec(previewBody = {}, options = {}) {
    const intervalMs = $cf31c85cca08914a$var$normalizePositiveInteger(options.intervalMs, $cf31c85cca08914a$var$DEFAULT_PREVIEW_INTERVAL_MS);
    const maxRequests = $cf31c85cca08914a$var$normalizePositiveInteger(options.maxRequests, $cf31c85cca08914a$var$DEFAULT_PREVIEW_MAX_REQUESTS);
    const timeoutSeconds = $cf31c85cca08914a$var$normalizePositiveInteger(options.timeoutSeconds, $cf31c85cca08914a$var$DEFAULT_PREVIEW_TIMEOUT_SECONDS);
    const reqId = String(previewBody?.reqId || crypto.randomUUID()).trim();
    if (!reqId) throw new Error('preview_request_id_required');
    await $cf31c85cca08914a$var$restApi.post('/occo-owner/process-image-preview', {
        ...previewBody,
        reqId: reqId
    }, {
        addAuth: true
    }).then($cf31c85cca08914a$var$unwrapOccoOwnerResponse);
    const startedAt = Date.now();
    let requestCount = 0;
    while(true){
        const result = await $cf31c85cca08914a$var$restApi.post('/occo-owner/process-image-preview/retrieve', {
            reqId: reqId
        }, {
            addAuth: true
        }).then($cf31c85cca08914a$var$unwrapOccoOwnerResponse);
        const status = String(result?.status || '').trim().toUpperCase();
        const previewResponse = $cf31c85cca08914a$var$normalizePreviewResponse(result);
        if (status === $cf31c85cca08914a$var$PREVIEW_STATUS_DONE || previewResponse.generatedResourceUrl || previewResponse.thumbImageUrl) {
            if (!previewResponse.generatedResourceUrl && !previewResponse.thumbImageUrl) throw new Error('Preview did not return an image.');
            return previewResponse;
        }
        if (status === $cf31c85cca08914a$var$PREVIEW_STATUS_FAILED) throw new Error($cf31c85cca08914a$var$getPreviewMessage(result, 'Failed to generate preview.'));
        if (Date.now() - startedAt > timeoutSeconds * 1000 || requestCount >= maxRequests) throw new Error('Preview is not ready. Please try again later.');
        requestCount += 1;
        await $cf31c85cca08914a$var$delay(intervalMs);
    }
}

});
parcelRegister("itWG1", function(module, exports) {

$parcel$export(module.exports, "uploadFileToAssets", function () { return $d748736fe8a691e9$export$a867ec813f0ac3cd; });

var $k2vBO = parcelRequire("k2vBO");
const $d748736fe8a691e9$var$restApi = (0, $k2vBO.initRequest)("https://api-new.occo.io/v1");
async function $d748736fe8a691e9$export$dcc226a3b00ee742({ eventName: eventName, fullPath: fullPath, attendeeUid: attendeeUid }) {
    return $d748736fe8a691e9$var$restApi.post('/event/create-attendee-custom-photo/async', {
        eventName: eventName,
        fullPath: fullPath,
        attendeeUid: attendeeUid
    });
}
async function $d748736fe8a691e9$export$5eb4cab3ea6a8455({ eventName: eventName, fileName: fileName, keepOriginName: keepOriginName, attendeeUid: attendeeUid, file: file }) {
    return $d748736fe8a691e9$var$restApi.post('/event/tmp-photo-upload-access/retrieve', {
        event_name: eventName,
        file_name: fileName,
        keep_origin_name: keepOriginName,
        attendee_uid: attendeeUid
    }).then(({ result: result })=>(0, $k2vBO.sendFileToS3)(file, {
            s3key: result.fields.key,
            s3bucketUrl: result.url,
            s3fields: result.fields,
            defaultFileType: file.type
        }));
}
async function $d748736fe8a691e9$export$a867ec813f0ac3cd({ fileRelativePath: fileRelativePath, file: file }) {
    return $d748736fe8a691e9$var$restApi.post('/occo-owner/asset/tmp-upload-access/retrieve', {
        file_relative_path: fileRelativePath
    }, {
        addAuth: true
    }).then(({ result: result })=>(0, $k2vBO.sendFileToS3)(file, {
            s3key: result.fields.key,
            s3bucketUrl: result.url,
            s3fields: result.fields,
            defaultFileType: file.type
        }));
}

});
parcelRegister("k2vBO", function(module, exports) {

$parcel$export(module.exports, "sendFileToS3", function () { return $e96c836b92e000d3$export$a66317a466bfa2d8; });
$parcel$export(module.exports, "initRequest", function () { return $e96c836b92e000d3$export$af0c4af558fd76ef; });

var $eD8Qa = parcelRequire("eD8Qa");
function $e96c836b92e000d3$var$recallAfterOffline(XMLHttpRequest1, fn) {
    if (XMLHttpRequest1.readyState === 0 || XMLHttpRequest1.readyState === 4) // Network error (i.e. connection refused, access denied due to CORS, etc.)
    window.addEventListener('online', ()=>{
        fn();
    }, {
        once: true
    });
}
async function $e96c836b92e000d3$export$a66317a466bfa2d8(file, { s3key: s3key, s3bucketUrl: s3bucketUrl, s3fields: s3fields, defaultImgPath: defaultImgPath, defaultFileType: defaultFileType = 'image/jpeg' }, { retryIfOffline: retryIfOffline = false } = {}) {
    return new Promise(function exec(resolve) {
        const xhr = new XMLHttpRequest();
        xhr.addEventListener('load', ()=>resolve(finalPath()), false);
        xhr.addEventListener('error', (err)=>{
            if (retryIfOffline) $e96c836b92e000d3$var$recallAfterOffline(err.currentTarget, ()=>exec(resolve));
        }, false);
        xhr.open('POST', s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND
        xhr.send(prepareFormData());
    });
    function prepareFormData() {
        const fd = new FormData();
        fd.append('key', s3key);
        fd.append('acl', 'public-read');
        fd.append('success_action_status', '201');
        fd.append('Content-Type', getFileType());
        fd.append('X-Amz-Credential', s3fields['X-Amz-Credential']);
        fd.append('X-Amz-Algorithm', s3fields['X-Amz-Algorithm']);
        fd.append('X-Amz-Date', s3fields['X-Amz-Date']);
        fd.append('X-Amz-Security-Token', s3fields['X-Amz-Security-Token']);
        fd.append('Policy', s3fields.Policy);
        fd.append('X-Amz-Signature', s3fields['X-Amz-Signature']);
        fd.append('file', file);
        return fd;
    }
    function finalPath() {
        if (s3fields.bucket) return `https://${s3fields.bucket}/${s3key}`;
        return `${defaultImgPath}/${s3key}`;
    }
    function getFileType() {
        return file.type && file.type !== '' ? file.type : defaultFileType;
    }
}
const $e96c836b92e000d3$export$af0c4af558fd76ef = (serverUrl)=>({
        post: async (path, body = {}, { addAuth: addAuth = false, retryIfOffline: retryIfOffline = false, extraHeaders: extraHeaders = null } = {})=>{
            let auth = null;
            if (addAuth) auth = await $e96c836b92e000d3$var$getAuthToken();
            return new Promise(function exec(resolve, reject) {
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'json';
                xhr.addEventListener('load', (event)=>{
                    resolve(event.currentTarget.response);
                }, false);
                xhr.addEventListener('error', (err)=>{
                    if (retryIfOffline) $e96c836b92e000d3$var$recallAfterOffline(err.currentTarget, ()=>exec(resolve));
                    else reject(err.currentTarget);
                }, false);
                xhr.open('POST', `${serverUrl}${path}`, true); // MUST BE LAST LINE BEFORE YOU SEND
                if (auth) xhr.setRequestHeader('Authorization', auth);
                if (extraHeaders) Object.entries(extraHeaders).forEach(([name, value])=>{
                    if (value != null) xhr.setRequestHeader(name, value);
                });
                xhr.send(JSON.stringify(body));
            });
        }
    });
async function $e96c836b92e000d3$var$getAuthToken() {
    const { idToken: idToken } = (0, $eD8Qa.getStoredTokens)();
    if (idToken) return (0, $eD8Qa.getIdToken)();
    // SDK fallback is only for non-SSO projects (webapp) that still load
    // the AmazonCognitoIdentity script. SSO projects (occo-portal, photo-album,
    // occo-admin) don't load it — with no stored SSO token the user is simply
    // unauthenticated, so reject cleanly instead of throwing "SDK not included".
    if (typeof AmazonCognitoIdentity !== 'undefined') return $e96c836b92e000d3$var$getAuthTokenFromSdk();
    throw new Error('unauthorized_user');
}
function $e96c836b92e000d3$var$getAuthTokenFromSdk() {
    return new Promise((resolve, reject)=>{
        const cognitoUser = getCurrentUser();
        if (cognitoUser == null) {
            reject(new Error('unauthorized_user'));
            return;
        }
        cognitoUser.getSession((err, session)=>{
            if (err || !session.isValid()) {
                const error = {
                    type: 'unauthorized_user'
                };
                if (err) error.innerError = err;
                reject(error);
            } else resolve(session.getIdToken().getJwtToken());
        });
        function getCurrentUser() {
            if (!AmazonCognitoIdentity) throw new Error('AmazonCognitoIdentity should be included');
            const userPool = new AmazonCognitoIdentity.CognitoUserPool({
                UserPoolId: "us-west-2_TIXPqIBIl",
                ClientId: "1o5s7hu2bvnd5q6g1a120vrirq"
            });
            return userPool.getCurrentUser();
        }
    });
}
function $e96c836b92e000d3$export$60955a2a33777029(input) {
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
    const seen = new WeakMap();
    function transform(value) {
        // string -> Date if matches ISO pattern
        if (typeof value === 'string') return isoRegex.test(value) ? new Date(value) : value;
        // keep Date instances as-is
        if (value instanceof Date) return value;
        // primitives and null
        if (value === null || typeof value !== 'object') return value;
        // handle circular references
        if (seen.has(value)) return seen.get(value);
        // arrays
        if (Array.isArray(value)) {
            const outArr = value.map((el)=>transform(el));
            seen.set(value, outArr);
            return outArr;
        }
        // plain or custom objects: preserve prototype
        const proto = Object.getPrototypeOf(value);
        const outObj = Object.create(proto);
        seen.set(value, outObj);
        for (const [k, v] of Object.entries(value))outObj[k] = transform(v);
        return outObj;
    }
    return transform(input);
}

});
parcelRegister("eD8Qa", function(module, exports) {

$parcel$export(module.exports, "getStoredTokens", function () { return $aa6b90b7716035e0$export$8bdfd37227c61428; });
$parcel$export(module.exports, "getIdToken", function () { return $aa6b90b7716035e0$export$393ade1005606e67; });
const $aa6b90b7716035e0$var$TOKEN_KEYS = {
    idToken: 'occo_cognito_sso.id_token',
    accessToken: 'occo_cognito_sso.access_token',
    refreshToken: 'occo_cognito_sso.refresh_token',
    expiresAt: 'occo_cognito_sso.expires_at'
};
const $aa6b90b7716035e0$var$PKCE_VERIFIER_KEY = 'occo_cognito_sso.pkce_verifier';
const $aa6b90b7716035e0$var$OAUTH_STATE_KEY = 'occo_cognito_sso.oauth_state';
const $aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY = 'occo_cognito_sso.return_to';
const $aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY = 'occo_cognito_sso.oauth_flow_started_at';
const $aa6b90b7716035e0$var$OAUTH_FLOW_KEYS = [
    $aa6b90b7716035e0$var$PKCE_VERIFIER_KEY,
    $aa6b90b7716035e0$var$OAUTH_STATE_KEY,
    $aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY
];
// Abandoned login attempts should not leave reusable state indefinitely.
const $aa6b90b7716035e0$var$OAUTH_FLOW_MAX_AGE_MS = 900000;
const $aa6b90b7716035e0$var$STALE_OAUTH_CALLBACK = 'STALE_OAUTH_CALLBACK';
const $aa6b90b7716035e0$var$EXPIRY_BUFFER_MS = 60000;
function $aa6b90b7716035e0$var$staleOAuthError(message) {
    const err = new Error(message);
    err.code = $aa6b90b7716035e0$var$STALE_OAUTH_CALLBACK;
    return err;
}
function $aa6b90b7716035e0$var$isStaleOAuthCallback(err) {
    return err?.code === $aa6b90b7716035e0$var$STALE_OAUTH_CALLBACK;
}
// OAuth state/PKCE live in localStorage (not sessionStorage) so they survive tab discard
// after long idle. sessionStorage is still read once for in-flight logins from older builds.
function $aa6b90b7716035e0$var$clearOAuthFlow() {
    $aa6b90b7716035e0$var$OAUTH_FLOW_KEYS.forEach((key)=>{
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    });
    localStorage.removeItem($aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY);
}
function $aa6b90b7716035e0$var$isOAuthFlowExpired() {
    const startedAt = Number(localStorage.getItem($aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY) || 0);
    return !startedAt || Date.now() - startedAt > $aa6b90b7716035e0$var$OAUTH_FLOW_MAX_AGE_MS;
}
function $aa6b90b7716035e0$var$readOAuthFlowKey(key) {
    if ($aa6b90b7716035e0$var$isOAuthFlowExpired()) {
        $aa6b90b7716035e0$var$clearOAuthFlow();
        return null;
    }
    return localStorage.getItem(key) ?? sessionStorage.getItem(key);
}
function $aa6b90b7716035e0$var$writeOAuthFlowKey(key, value) {
    localStorage.setItem(key, value);
    sessionStorage.removeItem(key);
}
function $aa6b90b7716035e0$var$finishOAuthFlow() {
    $aa6b90b7716035e0$var$clearOAuthFlow();
}
const $aa6b90b7716035e0$var$FORCE_LOGIN_KEY = 'occo_cognito_sso.force_login';
const $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS = 'redirecting_to_auth';
function $aa6b90b7716035e0$export$cec2144b6a46d4aa() {
    sessionStorage.setItem($aa6b90b7716035e0$var$FORCE_LOGIN_KEY, '1');
}
function $aa6b90b7716035e0$var$consumeLoginRequired() {
    if (sessionStorage.getItem($aa6b90b7716035e0$var$FORCE_LOGIN_KEY) !== '1') return false;
    sessionStorage.removeItem($aa6b90b7716035e0$var$FORCE_LOGIN_KEY);
    return true;
}
function $aa6b90b7716035e0$export$7a8cdd7c482119af(err) {
    return err?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS || err?.innerError?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS;
}
const $aa6b90b7716035e0$var$OAUTH_ERROR_HINTS = {
    redirect_mismatch: 'Register the redirect_uri in Cognito app client Allowed callback URLs (exact match, including trailing slash).',
    unauthorized_client: 'Use a public SPA app client with Authorization code grant, PKCE, openid/email/profile scopes, and Cognito user pool identity provider enabled.',
    access_denied: 'Sign-in was cancelled or access was denied.'
};
function $aa6b90b7716035e0$var$readEnv(key) {
    if (typeof window !== 'undefined' && window[key] !== undefined) return window[key];
    // Parcel only inlines static process.env.* access (not process.env[key])
    const env = {
        COGNITO_DOMAIN: "auth.occo.io",
        POOL_DATA_CLIENT_ID: "1o5s7hu2bvnd5q6g1a120vrirq",
        COGNITO_REDIRECT_URI: "https://photo.occo.io/index.html",
        COGNITO_LOGOUT_REDIRECT_URI: "https://photo.occo.io/index.html"
    };
    return env[key];
}
function $aa6b90b7716035e0$var$safeParseUrl(uri) {
    try {
        return new URL(uri);
    } catch  {
        return null;
    }
}
function $aa6b90b7716035e0$var$normalizeRedirectUri(uri) {
    // Cognito callback/sign-out URLs must match exactly. Strip any trailing slash so
    // both branches below (configured value vs. origin fallback) produce the same form.
    return uri.trim().replace(/\/+$/, '');
}
function $aa6b90b7716035e0$var$ensureStaticHostCallbackPath(uri) {
    // S3/CloudFront sub-path deploys (e.g. /armen-1) have no directory index — only
    // /armen-1/index.html exists. Bare /armen-1 returns NoSuchKey after OAuth.
    const url = $aa6b90b7716035e0$var$safeParseUrl(uri);
    if (!url) return uri;
    const path = url.pathname.replace(/\/+$/, '') || '/';
    if (path === '/' || /\.[a-zA-Z0-9]+$/.test(path)) return uri;
    return `${url.origin}${path}/index.html`;
}
function $aa6b90b7716035e0$var$resolveRedirectUri(envKey, fallbackKey) {
    const configured = $aa6b90b7716035e0$var$readEnv(envKey) || (fallbackKey ? $aa6b90b7716035e0$var$readEnv(fallbackKey) : null);
    if (typeof window !== 'undefined' && window.location?.origin) {
        const currentOrigin = window.location.origin;
        const configuredUrl = configured ? $aa6b90b7716035e0$var$safeParseUrl(configured) : null;
        if (configuredUrl) // Always return to the origin the app is actually running on, but keep the
        // configured callback PATH (e.g. /index.html). This lets a single dev/prod
        // COGNITO_REDIRECT_URI work on localhost without dropping the path — otherwise
        // a sub-path callback page would lose its path and the code would land on the
        return $aa6b90b7716035e0$var$ensureStaticHostCallbackPath($aa6b90b7716035e0$var$normalizeRedirectUri(`${currentOrigin}${configuredUrl.pathname}${configuredUrl.search}`));
        return $aa6b90b7716035e0$var$normalizeRedirectUri(currentOrigin);
    }
    if (!configured) throw new Error(`${envKey} is required`);
    return $aa6b90b7716035e0$var$ensureStaticHostCallbackPath($aa6b90b7716035e0$var$normalizeRedirectUri(configured));
}
function $aa6b90b7716035e0$var$getConfig() {
    const domain = ($aa6b90b7716035e0$var$readEnv('COGNITO_DOMAIN') || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
    const clientId = $aa6b90b7716035e0$var$readEnv('POOL_DATA_CLIENT_ID');
    const redirectUri = $aa6b90b7716035e0$var$resolveRedirectUri('COGNITO_REDIRECT_URI');
    const logoutRedirectUri = $aa6b90b7716035e0$var$resolveRedirectUri('COGNITO_LOGOUT_REDIRECT_URI', 'COGNITO_REDIRECT_URI');
    if (!domain) throw new Error('COGNITO_DOMAIN is required');
    if (!clientId) throw new Error('POOL_DATA_CLIENT_ID is required');
    return {
        domain: domain,
        clientId: clientId,
        redirectUri: redirectUri,
        logoutRedirectUri: logoutRedirectUri,
        scopes: 'openid email profile'
    };
}
function $aa6b90b7716035e0$var$base64UrlEncode(buffer) {
    const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    let binary = '';
    bytes.forEach((byte)=>{
        binary += String.fromCharCode(byte);
    });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $aa6b90b7716035e0$var$resolveExpiresAtMs({ expiresIn: expiresIn, idToken: idToken }) {
    if (expiresIn != null && Number.isFinite(Number(expiresIn))) return Date.now() + Number(expiresIn) * 1000;
    if (idToken) try {
        const payload = JSON.parse(atob(idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (payload.exp) return payload.exp * 1000;
    } catch  {
    /* malformed JWT — fall through */ }
    return Date.now() + 3600000;
}
function $aa6b90b7716035e0$var$saveTokens({ idToken: idToken, accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn }) {
    localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.idToken, idToken);
    localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.accessToken, accessToken);
    if (refreshToken) localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.refreshToken, refreshToken);
    localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.expiresAt, String($aa6b90b7716035e0$var$resolveExpiresAtMs({
        expiresIn: expiresIn,
        idToken: idToken
    })));
}
function $aa6b90b7716035e0$export$7809a8af6f3e4c63() {
    Object.values($aa6b90b7716035e0$var$TOKEN_KEYS).forEach((key)=>localStorage.removeItem(key));
    $aa6b90b7716035e0$var$clearOAuthFlow();
}
function $aa6b90b7716035e0$export$8bdfd37227c61428() {
    return {
        idToken: localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.idToken),
        accessToken: localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.accessToken),
        refreshToken: localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.refreshToken),
        expiresAt: Number(localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.expiresAt) || 0)
    };
}
function $aa6b90b7716035e0$var$isTokenExpired(expiresAt) {
    return !expiresAt || Date.now() >= expiresAt - $aa6b90b7716035e0$var$EXPIRY_BUFFER_MS;
}
function $aa6b90b7716035e0$export$2d1683f878dc8696() {
    const { idToken: idToken, expiresAt: expiresAt, refreshToken: refreshToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
    // Unexpired ID token, or expired ID + refresh (Cognito "keep logged in" window).
    // Without this, login pages skip getIdToken() refresh and force Hosted UI.
    if (!idToken) return false;
    if (!$aa6b90b7716035e0$var$isTokenExpired(expiresAt)) return true;
    return Boolean(refreshToken);
}
function $aa6b90b7716035e0$var$formatOAuthError(error, errorDescription) {
    const hint = $aa6b90b7716035e0$var$OAUTH_ERROR_HINTS[error];
    const detail = errorDescription || error || 'unknown_error';
    return hint ? `${detail}. ${hint}` : detail;
}
async function $aa6b90b7716035e0$var$requestTokens(body) {
    const { domain: domain } = $aa6b90b7716035e0$var$getConfig();
    const response = await fetch(`https://${domain}/oauth2/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: body
    });
    const data = await response.json().catch(()=>({}));
    if (!response.ok) throw new Error($aa6b90b7716035e0$var$formatOAuthError(data.error, data.error_description || `Token request failed (${response.status})`));
    return data;
}
async function $aa6b90b7716035e0$var$exchangeAuthorizationCode(code) {
    const { clientId: clientId, redirectUri: redirectUri } = $aa6b90b7716035e0$var$getConfig();
    const codeVerifier = $aa6b90b7716035e0$var$readOAuthFlowKey($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY);
    localStorage.removeItem($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY);
    sessionStorage.removeItem($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY);
    if (!codeVerifier) throw $aa6b90b7716035e0$var$staleOAuthError('Missing PKCE verifier. Restart sign-in.');
    const tokens = await $aa6b90b7716035e0$var$requestTokens(new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: clientId,
        code: code,
        redirect_uri: redirectUri,
        code_verifier: codeVerifier
    }));
    $aa6b90b7716035e0$var$saveTokens({
        idToken: tokens.id_token,
        accessToken: tokens.access_token,
        refreshToken: tokens.refresh_token,
        expiresIn: tokens.expires_in
    });
}
let $aa6b90b7716035e0$var$refreshInFlight = null;
async function $aa6b90b7716035e0$var$refreshIdToken() {
    if ($aa6b90b7716035e0$var$refreshInFlight) return $aa6b90b7716035e0$var$refreshInFlight;
    $aa6b90b7716035e0$var$refreshInFlight = (async ()=>{
        const { clientId: clientId } = $aa6b90b7716035e0$var$getConfig();
        const { refreshToken: refreshToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
        if (!refreshToken) throw new Error('No refresh token available');
        const tokens = await $aa6b90b7716035e0$var$requestTokens(new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: clientId,
            refresh_token: refreshToken
        }));
        const { idToken: previousIdToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
        $aa6b90b7716035e0$var$saveTokens({
            idToken: tokens.id_token || previousIdToken,
            accessToken: tokens.access_token,
            refreshToken: tokens.refresh_token || refreshToken,
            expiresIn: tokens.expires_in
        });
        return tokens.id_token || previousIdToken;
    })();
    try {
        return await $aa6b90b7716035e0$var$refreshInFlight;
    } finally{
        $aa6b90b7716035e0$var$refreshInFlight = null;
    }
}
async function $aa6b90b7716035e0$export$393ade1005606e67() {
    const { idToken: idToken, expiresAt: expiresAt } = $aa6b90b7716035e0$export$8bdfd37227c61428();
    if (!idToken) throw new Error('unauthorized_user');
    if ($aa6b90b7716035e0$var$isTokenExpired(expiresAt)) try {
        // Seamless background refresh — no page reload (mirrors the SDK's getSession).
        return await $aa6b90b7716035e0$var$refreshIdToken();
    } catch  {
        // A concurrent refresh may have succeeded while this one failed (rotated token).
        const retry = $aa6b90b7716035e0$export$8bdfd37227c61428();
        if (retry.idToken && !$aa6b90b7716035e0$var$isTokenExpired(retry.expiresAt)) return retry.idToken;
        $aa6b90b7716035e0$var$beginSilentReauth();
    }
    return idToken;
}
const $aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED = 'cognito_session_revoked';
const $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT = 'COGNITO_USERINFO_TRANSIENT';
/**
 * Ask Cognito whether the access token is still accepted.
 * After AdminUserGlobalSignOut / token revocation, /oauth2/userInfo returns 401 even
 * while the local JWT has not reached exp — that is how we force immediate logout.
 * Network / 5xx failures are marked transient so a Cognito blip does not sign users out.
 */ async function $aa6b90b7716035e0$var$assertCognitoSessionActive() {
    const { accessToken: accessToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
    if (!accessToken) {
        const err = new Error('No access token available');
        err.code = $aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED;
        throw err;
    }
    const { domain: domain } = $aa6b90b7716035e0$var$getConfig();
    let response;
    try {
        response = await fetch(`https://${domain}/oauth2/userInfo`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
    } catch (networkErr) {
        const err = new Error(networkErr?.message || 'userInfo network error');
        err.code = $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT;
        throw err;
    }
    if (response.ok) return;
    if (response.status === 401 || response.status === 403) {
        const err = new Error($aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED);
        err.code = $aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED;
        throw err;
    }
    const err = new Error(`userInfo failed (${response.status})`);
    err.code = $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT;
    throw err;
}
function $aa6b90b7716035e0$var$beginForcedLogout() {
    // Clear app tokens and the Hosted UI cookie so Cognito console "Sign out user" sticks
    // (authorize alone can silently re-issue tokens via the managed-login cookie).
    $aa6b90b7716035e0$export$b0ac3a1c242cb1ea();
    throw new Error($aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS);
}
async function $aa6b90b7716035e0$export$7b962f1e4c5494f() {
    const idToken = await $aa6b90b7716035e0$export$393ade1005606e67();
    try {
        await $aa6b90b7716035e0$var$assertCognitoSessionActive();
        return idToken;
    } catch (err) {
        if (err?.code === $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT) return idToken;
        try {
            await $aa6b90b7716035e0$var$refreshIdToken();
            await $aa6b90b7716035e0$var$assertCognitoSessionActive();
            return $aa6b90b7716035e0$export$8bdfd37227c61428().idToken;
        } catch (retryErr) {
            if (retryErr?.code === $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT) return $aa6b90b7716035e0$export$8bdfd37227c61428().idToken || idToken;
            if (retryErr?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS) throw retryErr;
            $aa6b90b7716035e0$var$beginForcedLogout();
        }
    }
}
function $aa6b90b7716035e0$var$beginSilentReauth() {
    $aa6b90b7716035e0$export$7809a8af6f3e4c63();
    $aa6b90b7716035e0$var$redirectToAuthorize(globalThis.location.href);
    // Fail fast so callers (guardPage / occoAPI) don't hang; navigation is already queued.
    throw new Error($aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS);
}
function $aa6b90b7716035e0$var$parseOAuthCallback() {
    const url = new URL(globalThis.location.href);
    return {
        code: url.searchParams.get('code'),
        state: url.searchParams.get('state'),
        error: url.searchParams.get('error'),
        errorDescription: url.searchParams.get('error_description')
    };
}
function $aa6b90b7716035e0$var$cleanOAuthUrl() {
    const url = new URL(globalThis.location.href);
    url.searchParams.delete('code');
    url.searchParams.delete('state');
    url.searchParams.delete('error');
    url.searchParams.delete('error_description');
    globalThis.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
}
async function $aa6b90b7716035e0$var$completeAuthorizationCallback(code, state) {
    const expectedState = $aa6b90b7716035e0$var$readOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_STATE_KEY);
    localStorage.removeItem($aa6b90b7716035e0$var$OAUTH_STATE_KEY);
    sessionStorage.removeItem($aa6b90b7716035e0$var$OAUTH_STATE_KEY);
    if (!expectedState || state !== expectedState) throw $aa6b90b7716035e0$var$staleOAuthError('Invalid OAuth state. Restart sign-in.');
    await $aa6b90b7716035e0$var$exchangeAuthorizationCode(code);
    $aa6b90b7716035e0$var$finishOAuthFlow();
    $aa6b90b7716035e0$var$cleanOAuthUrl();
}
function $aa6b90b7716035e0$var$consumeReturnTo() {
    const returnTo = $aa6b90b7716035e0$var$readOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY);
    localStorage.removeItem($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY);
    sessionStorage.removeItem($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY);
    if (!returnTo) return null;
    // Only honor same-origin targets to avoid being used as an open redirect.
    try {
        if (new URL(returnTo, window.location.origin).origin === window.location.origin) return returnTo;
    } catch  {
    /* malformed return target — ignore */ }
    return null;
}
async function $aa6b90b7716035e0$var$redirectToAuthorize(returnTo) {
    const { domain: domain, clientId: clientId, redirectUri: redirectUri, scopes: scopes } = $aa6b90b7716035e0$var$getConfig();
    $aa6b90b7716035e0$var$clearOAuthFlow();
    const verifierBytes = new Uint8Array(32);
    crypto.getRandomValues(verifierBytes);
    const codeVerifier = $aa6b90b7716035e0$var$base64UrlEncode(verifierBytes);
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
    const codeChallenge = $aa6b90b7716035e0$var$base64UrlEncode(digest);
    const stateBytes = new Uint8Array(16);
    crypto.getRandomValues(stateBytes);
    const oauthState = $aa6b90b7716035e0$var$base64UrlEncode(stateBytes);
    localStorage.setItem($aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY, String(Date.now()));
    $aa6b90b7716035e0$var$writeOAuthFlowKey($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY, codeVerifier);
    $aa6b90b7716035e0$var$writeOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_STATE_KEY, oauthState);
    if (returnTo) $aa6b90b7716035e0$var$writeOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY, returnTo);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: clientId,
        redirect_uri: redirectUri,
        scope: scopes,
        code_challenge_method: 'S256',
        code_challenge: codeChallenge,
        state: oauthState
    });
    window.location.assign(`https://${domain}/oauth2/authorize?${params}`);
}
function $aa6b90b7716035e0$export$b0ac3a1c242cb1ea({ logoutRedirectUri: logoutRedirectUri } = {}) {
    const { domain: domain, clientId: clientId, logoutRedirectUri: defaultLogoutUri } = $aa6b90b7716035e0$var$getConfig();
    $aa6b90b7716035e0$export$7809a8af6f3e4c63();
    const params = new URLSearchParams({
        client_id: clientId,
        logout_uri: logoutRedirectUri || defaultLogoutUri
    });
    window.location.assign(`https://${domain}/logout?${params}`);
}
async function $aa6b90b7716035e0$export$1635fd45e10df58b({ redirectAfterLogin: redirectAfterLogin, onSuccess: onSuccess, onError: onError }) {
    const { error: error, errorDescription: errorDescription, code: code, state: state } = $aa6b90b7716035e0$var$parseOAuthCallback();
    if (error) {
        $aa6b90b7716035e0$var$cleanOAuthUrl();
        onError?.(new Error($aa6b90b7716035e0$var$formatOAuthError(error, errorDescription)));
        return;
    }
    if (code) {
        try {
            await $aa6b90b7716035e0$var$completeAuthorizationCallback(code, state);
            if (onSuccess) await onSuccess();
            window.location.href = $aa6b90b7716035e0$var$consumeReturnTo() || redirectAfterLogin;
        } catch (err) {
            $aa6b90b7716035e0$var$cleanOAuthUrl();
            if ($aa6b90b7716035e0$var$isStaleOAuthCallback(err)) {
                $aa6b90b7716035e0$var$redirectToAuthorize($aa6b90b7716035e0$var$consumeReturnTo() ?? undefined).catch((redirectErr)=>onError?.(redirectErr));
                return;
            }
            onError?.(err);
        }
        return;
    }
    if ($aa6b90b7716035e0$var$consumeLoginRequired()) $aa6b90b7716035e0$export$7809a8af6f3e4c63();
    else if ($aa6b90b7716035e0$export$2d1683f878dc8696()) try {
        await $aa6b90b7716035e0$export$7b962f1e4c5494f();
        // Re-sync role/username even when reusing a valid session, otherwise a session
        // restored without onSuccess leaves the portal showing the generic 'User'.
        // Best-effort: a sync failure must not block an already-authenticated user.
        try {
            if (onSuccess) await onSuccess();
        } catch  {
        /* destination page reloads user info itself */ }
        window.location.href = redirectAfterLogin;
        return;
    } catch (err) {
        $aa6b90b7716035e0$export$7809a8af6f3e4c63();
        if (err?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS) return;
    }
    try {
        await $aa6b90b7716035e0$var$redirectToAuthorize();
    } catch (err) {
        onError?.(err);
    }
}

});





//# sourceMappingURL=storibox.0b67511f.js.map
